/* INTEGY V520 — iPhone landscape/Fold commerce owner.
   Uses touch + short-viewport geometry instead of the obsolete 989px landscape cap,
   blocks Empire's inline header-search fallback, and normalizes blank-search BFCache restores. */

/* ---- consolidated from integy-v484-commerce-owner.js ---- */
/* INTEGY V484 — consolidated mobile commerce owner. V484 replaces the V483 runtime owner
   and adds universal Recently Viewed rail repair plus explicit iPhone landscape-phone ownership.
   Preserves V483/V478 aliases, keyboard-aware iPhone landscape search geometry,
   scroll restoration, canonical Maxx scale labels, title-first taxonomy fixes,
   and prevents wide/short iPhones from being classified as tablets. */
(function () {
  'use strict';

  if (window.IntegyV520CommerceOwner) return;
  var V520Owner = window.IntegyV520CommerceOwner = window.IntegyV505CommerceOwner = window.IntegyV504CommerceOwner = window.IntegyV501CommerceOwner = window.IntegyV500CommerceOwner = window.IntegyV499CommerceOwner = window.IntegyV495CommerceOwner = { version: 'V520' };




  var root = document.documentElement;
  var openButton = null;
  var activeSearch = null;
  var lastFocus = null;
  var commerceObserver = null;
  var polishTimer = 0;
  var pendingScopes = [];
  var originalParent = null;
  var originalNext = null;
  var queryListenerInput = null;
  var GENERIC_FITMENT = /^(?:all integy hop[- ]?up parts|all products|products|bargain outlet center|boats|parts for more rc vehicles|integy hop[- ]?ups? for more rc vehicles|one[- ]of[- ]a[- ]kind,? open box,? scratch\s*(?:&|and)\s*dent)$/i;
  var FILTER_COLORS = { black:1, blue:1, bronze:1, brown:1, chrome:1, clear:1, gold:1, green:1, grey:1, gray:1, gunmetal:1, orange:1, pink:1, purple:1, red:1, silver:1, smoke:1, titanium:1, white:1, yellow:1 };
  var broadMobileQuery = window.matchMedia ? window.matchMedia('(max-width: 860px), (pointer: coarse) and (max-width: 1368px), (any-pointer: coarse) and (max-width: 1368px)') : null;
  var portraitPhoneQuery = window.matchMedia ? window.matchMedia('(max-width: 600px)') : null;
  var landscapeTouchQuery = window.matchMedia ? window.matchMedia('(orientation: landscape) and (max-height: 720px) and (max-width: 1200px) and (any-pointer: coarse)') : null;
  var foldQuery = window.matchMedia ? window.matchMedia('(pointer: coarse) and (min-width: 601px) and (max-width: 900px), (any-pointer: coarse) and (min-width: 601px) and (max-width: 900px)') : null;
  var lastHeaderY = window.scrollY || 0;
  var lastDeviceMode = '';
  var deviceFrame = 0;
  var headerTicking = false;
  var searchViewportFrame = 0;
  var searchOpenScrollY = 0;
  var searchPageState = null;

  function viewportBox() {
    var vv = window.visualViewport;
    return {
      width: Math.max(1, Math.round(vv ? vv.width : window.innerWidth || root.clientWidth || 1)),
      height: Math.max(1, Math.round(vv ? vv.height : window.innerHeight || root.clientHeight || 1))
    };
  }

  function landscapePhone() {
    var box = viewportBox();
    var geometryMatch = box.width > box.height && box.width <= 1200 && box.height <= 720;
    var mediaMatch = !!(landscapeTouchQuery && landscapeTouchQuery.matches);
    return geometryMatch && (mediaMatch || hasTouchCapability());
  }

  function compactPhone() {
    return !!((portraitPhoneQuery && portraitPhoneQuery.matches) || landscapePhone());
  }

  function broadMobile() {
    return !!(broadMobileQuery && broadMobileQuery.matches);
  }

  function foldTouch() {
    return !!(foldQuery && foldQuery.matches && !landscapePhone());
  }

  function compactCommerce() {
    return compactPhone() || foldTouch();
  }

  function syncSearchVisualViewport() {
    searchViewportFrame = 0;
    if (!activeSearch || !root.classList.contains('integy-v446-search-open')) return;
    var vv = window.visualViewport;
    var width = Math.max(1, Math.round(vv ? vv.width : window.innerWidth || root.clientWidth || 1));
    var height = Math.max(1, Math.round(vv ? vv.height : window.innerHeight || root.clientHeight || 1));
    var rawTop = Math.max(0, Math.round(vv ? vv.offsetTop : 0));
    var rawLeft = Math.max(0, Math.round(vv ? vv.offsetLeft : 0));
    var layoutHeight = Math.max(window.innerHeight || 0, root.clientHeight || 0, height);
    var focusedSearch = document.activeElement && document.activeElement.matches && document.activeElement.matches('input[type="search"],input[name="q"]');
    var keyboardOpen = compactCommerce() && ((layoutHeight - height > Math.max(110, layoutHeight * 0.18)) || (width > height && height < 390 && focusedSearch));
    var landscape = landscapePhone();
    /* INTEGY V532 — landscape search is an absolute document-layer aligned to
       the visual viewport's *page* coordinates. This avoids the iOS failure mode
       where a fixed body + fixed dialog + visualViewport.offsetTop all move in
       different coordinate systems after the keyboard pans Safari's viewport. */
    var pageTop = vv && Number.isFinite(vv.pageTop) ? vv.pageTop : ((window.scrollY || window.pageYOffset || 0) + rawTop);
    var pageLeft = vv && Number.isFinite(vv.pageLeft) ? vv.pageLeft : ((window.scrollX || window.pageXOffset || 0) + rawLeft);
    var top = landscape ? Math.max(0, Math.round(pageTop)) : rawTop;
    var left = landscape ? Math.max(0, Math.round(pageLeft)) : rawLeft;
    root.style.setProperty('--integy-v501-search-top', top + 'px');
    root.style.setProperty('--integy-v501-search-left', left + 'px');
    root.style.setProperty('--integy-v501-search-width', width + 'px');
    root.style.setProperty('--integy-v501-search-height', height + 'px');
    root.classList.toggle('integy-v501-keyboard-open', keyboardOpen);
    activeSearch.classList.toggle('integy-v501-keyboard-open', keyboardOpen);
    root.classList.toggle('integy-v532-landscape-search', landscape);
    activeSearch.classList.toggle('integy-v532-landscape-search', landscape);
  }

  function scheduleSearchVisualViewport() {
    if (searchViewportFrame) window.cancelAnimationFrame(searchViewportFrame);
    searchViewportFrame = window.requestAnimationFrame(syncSearchVisualViewport);
  }

  function clearSearchVisualViewport() {
    if (searchViewportFrame) window.cancelAnimationFrame(searchViewportFrame);
    searchViewportFrame = 0;
    ['--integy-v501-search-top','--integy-v501-search-left','--integy-v501-search-width','--integy-v501-search-height'].forEach(function (name) {
      root.style.removeProperty(name);
    });
    root.classList.remove('integy-v501-keyboard-open', 'integy-v532-landscape-search');
  }

  function hasTouchCapability() {
    var points = Number(navigator.maxTouchPoints || navigator.msMaxTouchPoints || 0);
    var coarse = false;
    try { coarse = window.matchMedia('(any-pointer: coarse)').matches; } catch (error) {}
    return points > 0 || coarse;
  }

  function classifyDeviceLayout() {
    var width = Math.max(root.clientWidth || 0, window.innerWidth || 0);
    var shortLandscapePhone = landscapePhone();
    var mode = 'desktop';
    if (width <= 600 || shortLandscapePhone) mode = shortLandscapePhone ? 'phone-landscape' : 'phone';
    else if (width <= 1368 && hasTouchCapability()) mode = 'touch-tablet';
    root.classList.toggle('integy-v450-phone', mode === 'phone' || mode === 'phone-landscape');
    root.classList.toggle('integy-v450-touch-tablet', mode === 'touch-tablet');
    root.classList.toggle('integy-v450-desktop', mode === 'desktop');
    root.classList.toggle('integy-v495-phone-landscape', mode === 'phone-landscape');
    root.setAttribute('data-integy-v450-device', mode);
    root.classList.toggle('integy-v478-fold-touch', mode === 'touch-tablet' && width <= 900);
    if (mode !== lastDeviceMode) {
      lastDeviceMode = mode;
      try { window.dispatchEvent(new CustomEvent('integy:v450:devicechange', { detail: { mode: mode, width: width } })); } catch (error) {}
    }
  }

  function scheduleDeviceLayout() {
    if (deviceFrame) window.cancelAnimationFrame(deviceFrame);
    deviceFrame = window.requestAnimationFrame(function () { deviceFrame = 0; classifyDeviceLayout(); });
  }

  function query(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }

  function all(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }

  // V520: model and part filter presentation is owned only by IntegyV520FilterExperience.
  function sortFilterLists() { return; }

  function normalizeSearchInput(input) {
    if (!input) return;
    if (!input.getAttribute('placeholder') || input.getAttribute('placeholder') === 'search.form.placeholder') {
      input.setAttribute('placeholder', 'What are you looking for?');
    }
    input.setAttribute('data-integy-v473-visible-input', 'true');
    var values = { color: '#ffffff', webkitTextFillColor: '#ffffff', caretColor: '#ffffff', opacity: '1', visibility: 'visible', textShadow: 'none', textIndent: '0px', letterSpacing: 'normal' };
    Object.keys(values).forEach(function (key) { try { input.style[key] = values[key]; } catch (error) {} });
  }

  function bindVisibleInput(input) {
    if (!input) return;
    normalizeSearchInput(input);
    if (input.getAttribute('data-integy-v473-visibility-bound') === 'true') return;
    input.setAttribute('data-integy-v473-visibility-bound', 'true');
    ['focus','input','change','keyup','compositionstart','compositionupdate','compositionend'].forEach(function (name) {
      input.addEventListener(name, function () { normalizeSearchInput(input); }, { passive: true });
    });
  }

  function getSearch(button) {
    if (activeSearch && document.contains(activeSearch)) return activeSearch;
    var header = button && button.closest ? button.closest('[data-site-header-main], .site-header-main, .site-header') : null;
    return query('[data-integy-v426-search], .live-search', header || document) || query('[data-integy-v426-search], .live-search');
  }

  function ensureQuickPanel(search) {
    if (!search) return null;
    var input = query('input[type="search"][name="q"], input[type="search"]', search);
    var owner = window.IntegyV520SearchOwner;
    if (owner && typeof owner.mountForInput === 'function') return owner.mountForInput(input);
    return document.getElementById('integy-v520-search-panel');
  }

  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function v626LocalizedPath(path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return v626RootPath() + cleanPath;
  }

  function restoreQuickPanel() {
    var owner = window.IntegyV520SearchOwner;
    if (owner && typeof owner.close === 'function') {
      try { owner.close(); } catch (error) {}
    }
    if (owner && typeof owner.restorePanel === 'function') {
      try { owner.restorePanel(); } catch (error) {}
    }
  }

  function ensureTakeoverChrome(search) {
    var toolbar = query('.integy-v464-search-toolbar', search);
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'integy-v464-search-toolbar';
      toolbar.innerHTML = '<strong>Search INTEGY</strong><button type="button" class="integy-v464-search-close" data-live-search-takeover-cancel aria-label="Close search">Close</button>';
      search.insertBefore(toolbar, search.firstChild);
    }

    var helper = query('.integy-v464-search-helper', search);
    if (!helper) {
      helper = document.createElement('div');
      helper.className = 'integy-v464-search-helper';
      helper.innerHTML = '<p>Search by SKU, vehicle, model, or part name.</p><div class="integy-v464-search-shortcuts"><a href="' + v626LocalizedPath('collections') + '">Shop by vehicle</a><a href="' + v626LocalizedPath('collections/rc-tools') + '">RC tools</a><a href="' + v626LocalizedPath('collections/rc-electronics') + '">RC electronics</a></div>';
      search.appendChild(helper);
    }

    var input = query('input[type="search"][name="q"], input[type="search"]', search);
    bindVisibleInput(input);
    if (input && input !== queryListenerInput) {
      queryListenerInput = input;
      input.addEventListener('input', function () {
        var hasQuery = !!String(input.value || '').trim();
        search.classList.toggle('integy-v464-search-has-query', hasQuery);
        if (root.classList.contains('integy-v446-search-open')) ensureQuickPanel(search);
      });
    }
    if (input) search.classList.toggle('integy-v464-search-has-query', !!String(input.value || '').trim());
    var panel = ensureQuickPanel(search);
    var form = query('.live-search-form, form[action*="/search"], form[role="search"]', search);
    if (form && helper && helper.parentNode !== form) {
      var nativeFlydown = query('[data-live-search-flydown], .search-flydown', form);
      var reference = nativeFlydown && nativeFlydown.parentNode === form ? nativeFlydown : null;
      if (reference) form.insertBefore(helper, reference);
      else form.appendChild(helper);
    }
  }

  function lockSearchPage(search) {
    if (!search || searchPageState) return;
    var body = document.body;
    var bodyStyle = body.style;
    var siblings = [];
    Array.prototype.forEach.call(body.children || [], function (node) {
      if (node === search || /^(?:SCRIPT|STYLE|LINK|TEMPLATE)$/.test(node.tagName || '')) return;
      siblings.push({
        node: node,
        inert: !!node.inert,
        ariaHidden: node.getAttribute('aria-hidden')
      });
      try { node.inert = true; } catch (error) {}
      node.setAttribute('aria-hidden', 'true');
    });
    searchPageState = {
      body: {
        position: bodyStyle.position,
        top: bodyStyle.top,
        left: bodyStyle.left,
        right: bodyStyle.right,
        width: bodyStyle.width,
        overflow: bodyStyle.overflow
      },
      siblings: siblings,
      landscape: landscapePhone()
    };
    /* INTEGY V532 — do not freeze the body with position:fixed in phone
       landscape. iOS Safari may pan the visual viewport when the keyboard opens;
       a fixed body puts the dialog in a different coordinate space. The dialog
       itself becomes an absolute visual-viewport layer in CSS instead. */
    if (!searchPageState.landscape) {
      bodyStyle.position = 'fixed';
      bodyStyle.top = (-searchOpenScrollY) + 'px';
      bodyStyle.left = '0';
      bodyStyle.right = '0';
      bodyStyle.width = '100%';
    }
    bodyStyle.overflow = 'hidden';
    search.setAttribute('role', 'dialog');
    search.setAttribute('aria-modal', 'true');
    search.setAttribute('aria-label', 'Search INTEGY');
  }

  function unlockSearchPage(search) {
    if (!searchPageState) return;
    var bodyStyle = document.body.style;
    Object.keys(searchPageState.body).forEach(function (name) { bodyStyle[name] = searchPageState.body[name] || ''; });
    searchPageState.siblings.forEach(function (entry) {
      if (!entry.node || !entry.node.isConnected) return;
      try { entry.node.inert = entry.inert; } catch (error) {}
      if (entry.ariaHidden === null) entry.node.removeAttribute('aria-hidden');
      else entry.node.setAttribute('aria-hidden', entry.ariaHidden);
    });
    if (search) {
      search.removeAttribute('aria-modal');
      search.removeAttribute('role');
      search.removeAttribute('aria-label');
    }
    searchPageState = null;
  }

  function mountToBody(search) {
    if (!search || search.parentNode === document.body) return;
    originalParent = search.parentNode;
    originalNext = search.nextSibling;
    document.body.appendChild(search);
  }

  function restoreSearch(search) {
    if (!search || !originalParent) return;
    try {
      if (originalNext && originalNext.parentNode === originalParent) originalParent.insertBefore(search, originalNext);
      else originalParent.appendChild(search);
    } catch (error) {}
    originalParent = null;
    originalNext = null;
  }

  function openSearch(button) {
    if (!compactCommerce()) return;
    if (activeSearch && root.classList.contains('integy-v446-search-open')) {
      var activeInput = query('input[type="search"][name="q"], input[type="search"]', activeSearch);
      if (activeInput) { try { activeInput.focus({ preventScroll: true }); } catch (error) { activeInput.focus(); } }
      return;
    }
    var search = getSearch(button);
    var input = query('input[type="search"][name="q"], input[type="search"]', search);
    if (!search || !input) {
      window.location.assign(v626LocalizedPath('search'));
      return;
    }

    searchOpenScrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    lastFocus = document.activeElement;
    openButton = button;
    activeSearch = search;
    bindVisibleInput(input);
    mountToBody(search);
    ensureTakeoverChrome(search);
    ensureQuickPanel(search);

    root.classList.remove('integy-v462-header-hidden');
    root.classList.add('integy-v446-search-open', 'integy-v462-header-locked', 'integy-v501-search-open');
    document.body.classList.add('mobile-search-takeover-active', 'integy-v501-search-lock');
    search.classList.add('live-search--takeover', 'live-search--focused', 'active', 'visible', 'integy-v501-body-search');
    lockSearchPage(search);
    scheduleSearchVisualViewport();
    search.setAttribute('data-animation-state', 'open');
    search.setAttribute('aria-hidden', 'false');
    if (button) button.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      normalizeSearchInput(input);
      ensureQuickPanel(search);
      try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
      try { input.setSelectionRange(input.value.length, input.value.length); } catch (error) {}
      if (String(input.value || '').trim().length >= 2) {
        try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (error) {}
      }
      scheduleSearchVisualViewport();
      window.setTimeout(scheduleSearchVisualViewport, 80);
      window.setTimeout(scheduleSearchVisualViewport, 280);
    });
  }

  function closeSearch(options) {
    options = options || {};
    var search = activeSearch || query('body > .live-search.live-search--takeover, .live-search.live-search--takeover');
    var button = openButton || query('[data-mobile-search-button],.site-header-mobile-search-button');
    if (window.IntegyV520SearchOwner && typeof window.IntegyV520SearchOwner.close === 'function') {
      try { window.IntegyV520SearchOwner.close(); } catch (error) {}
    }
    restoreQuickPanel();
    if (search) {
      search.classList.remove('live-search--takeover', 'live-search--active', 'live-search--focused', 'active', 'visible', 'integy-v501-body-search', 'integy-v501-keyboard-open', 'integy-v464-search-has-query', 'integy-v532-landscape-search');
      search.setAttribute('data-animation-state', 'closed');
      search.removeAttribute('aria-hidden');
      unlockSearchPage(search);
      restoreSearch(search);
    }
    root.classList.remove('integy-v446-search-open', 'integy-v462-header-locked', 'integy-v501-search-open');
    document.body.classList.remove('mobile-search-takeover-active', 'search-takeover-active', 'integy-v501-search-lock');
    if (!search) unlockSearchPage(null);
    clearSearchVisualViewport();
    if (button) button.setAttribute('aria-expanded', 'false');
    activeSearch = null;
    openButton = null;
    var restoreY = searchOpenScrollY;
    searchOpenScrollY = 0;
    window.requestAnimationFrame(function () { try { window.scrollTo(0, restoreY); } catch (error) {} });

    if (!options.skipFocus) {
      var target = button || lastFocus;
      if (target && typeof target.focus === 'function') {
        window.setTimeout(function () {
          try { target.focus({ preventScroll: true }); }
          catch (error) { try { target.focus(); } catch (ignored) {} }
        }, 0);
      }
    }
  }


  function compactHeaderLocked() {
    return root.classList.contains('integy-v446-search-open') ||
      root.classList.contains('integy-v466-filter-open') ||
      !!query('.live-search--takeover.active,.live-search--takeover.visible,[data-mobile-nav][data-open="true"],[data-mobile-nav-panel][data-animation-state="open"]');
  }

  function updateCompactHeader() {
    headerTicking = false;
    if (!compactPhone()) {
      root.classList.remove('integy-v462-header-hidden','integy-v462-header-locked');
      lastHeaderY = window.scrollY || 0;
      return;
    }
    var y = Math.max(0, window.scrollY || 0);
    var focused = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName || '');
    var locked = compactHeaderLocked() || focused;
    root.classList.toggle('integy-v462-header-locked', !!locked);
    if (locked || y < 90 || y < lastHeaderY - 8) root.classList.remove('integy-v462-header-hidden');
    else if (y > lastHeaderY + 8) root.classList.add('integy-v462-header-hidden');
    lastHeaderY = y;
  }

  function requestCompactHeader() {
    if (headerTicking) return;
    headerTicking = true;
    window.requestAnimationFrame(updateCompactHeader);
  }

  function cleanText(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }

  function titleForTypeNode(node) {
    var card = node && node.closest ? node.closest('[data-product-item],.productgrid--item,.integy-v426-search-card,.integy-v426-search-suggestion,.product-main,.product--outer') : null;
    var titleNode = card && query('.productitem--title,.integy-v426-search-card__body h2,.integy-v426-search-suggestion__copy strong,.product-title,h1', card);
    return cleanText(titleNode && titleNode.textContent);
  }

  function displayTypeFromTitle(title, current) {
    if (window.IntegyV550Type && typeof window.IntegyV550Type.resolve === 'function') {
      var v550Type = window.IntegyV550Type.resolve(title, current);
      if (v550Type) return v550Type;
    }
    var text = (cleanText(title) + ' ' + cleanText(current)).toLowerCase();
    var head = cleanText(title).toLowerCase().split(/\s+(?:w\/\s*|with\s+|compatible\s+with\s+|for\s+)/i)[0] || '';
    if (/\bsuspension\s+conversion\s+kits?\b/.test(head)) return 'Suspension Conversion Kit';
    if (/\b(?:hand\s+twist\s+drill|hand\s+drill|pin\s+vise)\b/.test(head)) return 'Hand Drill';
    if (/\bsteering\s+saver\b/.test(head) && /\bbell\s*crank\b/.test(head)) return 'Steering Bellcrank / Saver';
    if (/\b(?:servo\s+adjustable\s+saver|adjustable\s+servo\s+saver)\b/.test(head)) return 'Servo Saver';
    if (/\bresistors?\b/.test(head)) return 'Resistor';
    if (/\bpinion\s+gear\s+(?:puller|remover)|\bgear\s+puller\s+remover|\bpinion\s+puller\b/.test(text)) return 'Pinion Gear Tool';
    if (/\bsteering\s+(?:linkage\s+)?tie\s+rod|\btie\s+rod\s+upgrade\b/.test(text)) return 'Steering Tie Rod';
    if (/\brc\s+crawler\s+kit\b|\bchassis(?:\s+only)?\s+kit\b|\b(?:crawler|buggy|truggy|touring\s+car|drift\s+car|monster\s+truck|short\s+course\s+truck|military\s+truck)\s+(?:rtr|artr|kit)\b/.test(text)) return 'RC Vehicle / Kit';
    if (/\bflat\s+washers?\b|\bwashers?\s+(?:set|pack|kit)\b/.test(text)) return 'Washer';
    if (/\be[- ]?clips?\b/.test(text)) return 'E-Clip';
    if (/\bwheel\s+nuts?\b/.test(text)) return 'Wheel Nut';
    if (/\block\s+nuts?\b/.test(text)) return 'Lock Nut';
    if (/\bshims?\s+(?:set|pack|kit)\b/.test(text)) return 'Shim';
    if (/\bspacers?\s+(?:set|pack|kit)\b/.test(text)) return 'Spacer';
    if (/\bscrews?\s+(?:set|pack|kit)\b/.test(text)) return 'Screw / Hardware';
    if (/\bled\s+lights?\s+(?:kit|set)\b/.test(text)) return 'LED Light Kit';
    if (/\bled\s+lights?\b/.test(text)) return 'LED Light';
    if (/\bmotor\s+(?:tester|analyzer)\b/.test(text)) return 'Motor Tester';
    if (/\bbrushless\s+motor\b/.test(text)) return 'Brushless Motor';
    if (/\bscrew\s*drivers?\b|\bscrewdrivers?\b/.test(text)) return 'Screwdriver';
    if (/\barm\s+reamer\b/.test(text)) return 'Arm Reamer';
    if (/\bbearing\s+(?:removal\s+tool|size\s+checker)\b/.test(text)) return 'Bearing Tool';
    if (/\b(?:tool\s+bag|tool\s+case|carrying\s+case)\b/.test(text)) return 'Tool Bag / Case';
    if (/transmitter\s+stick\s+ends?/.test(text)) return 'Transmitter Stick Ends';
    if (/flysky\s+noble|noble\s+nb4|color\s+ips\s+touch/.test(text)) return 'Radio System';
    if (/front\s+fork/.test(text)) return 'Front Fork';
    if (/side\s+protector/.test(text)) return 'Side Protector';
    if (/front\s+fender|rear\s+fender/.test(text)) return 'Fender';
    if (/windows?\s+control\s+panel\s+trim/.test(text)) return 'Interior Trim';
    if (/\b(?:rtr|ready[- ]to[- ]run|artr|almost[- ]ready[- ]to[- ]run)\b/.test(text) && /\b(?:rc\s+)?(?:truck|car|vehicle|crawler|buggy|truggy|monster\s+truck|touring\s+car|pickup)\b/.test(text)) return 'RC Vehicle / Kit';
    if (/(?:fog[- ]?light|window|door|dashboard).*\btrim\b|\btrim\s+(?:cover|panel|strip)\b/.test(text)) return 'Trim / Cover';
    if (/center\s+console.*(?:organizer|storage|tray)/.test(text)) return 'Center Console Organizer';
    if (/door\s+handle/.test(text)) return 'Door Handle Accessory';
    if (/center\s+console\s+cup\s+holder/.test(text)) return 'Cup Holder Insert';
    if (/screen\s+sunshade/.test(text)) return 'Screen Sunshade';
    if (/gauge\s+cluster/.test(text)) return 'Gauge Cluster';
    if (/piston.*spacer|spacer.*piston/.test(text)) return 'Shock Piston / Spacer';
    if (/jst.*(?:wire\s+harness|conversion)|wire\s+harness.*jst/.test(text)) return 'Connector / Wire Harness';
    if (/(?:camera\s+mount|frame\s+w\/\s*camera\s+mount)/.test(text) && /(?:flysky|radio|transmitter)/.test(text)) return 'Radio Camera Mount';
    if (/rear\s+hub\s+carrier|front\s+hub\s+carrier|\bhub\s+carrier\b/.test(text)) return 'Hub Carrier';
    if (/euro\s+plug\s+motor\s+post/.test(text)) return 'Motor Connector';
    if (/euro\s+plug\s+(?:male|female)/.test(text)) return 'Connector / Plug';
    if (/\bbattery\s+bar\b/.test(text)) return 'Battery Bar';
    if (/serration\s+bit/.test(text)) return 'Serration Bit';
    if (/steering\s+bell\s*crank|steering\s+bellcrank/.test(text)) return 'Steering Bellcrank';
    if (/center\s+of\s+gravity\s+gauge/.test(text)) return 'Center of Gravity Gauge';
    if (/angle\s+gauge/.test(text)) return 'Angle Gauge';
    if (/spur\s+gear\s+cover/.test(text)) return 'Spur Gear Cover';
    if (/adjustable\s+battery\s+mount\s+plate|battery\s+mount\s+plate|battery\s+tray/.test(text)) return 'Battery Mount / Tray';
    if (/battery\s+hold[- ]?down\s+plate/.test(text)) return 'Battery Hold-Down';
    return '';
  }

  function normalizeDynamicTypes(scope) {
    // V725: display types belong to the catalog; do not rewrite supplied labels.
  }

  function normalizeLegacyVehicleScaleLabels(scope) {
    var selector = [
      'a[href*="/collections/"]','[data-menu] a','.site-navigation a','.navmenu a',
      '.collection-filters__filter-list-item-text','[data-integy-v188-label]',
      '[data-integy-filter-value-label]','.integy-v188-model-filter__label',
      '.integy-v187-model-filter__label','.integy-v201-filter-label'
    ].join(',');
    all(selector, scope || document).forEach(function (node) {
      var text = cleanText(node.textContent), replacement = '';
      if (/^1\/6\s+Maxx\s+4S(?:\s*\/\s*Maxx\s+V2\s+WideMaxx)?(?:\s*\(\d+\))?$/i.test(text)) replacement = text.replace(/^1\/6/i, '1/10');
      else if (/^1\/6\s+Maxx\s+V2\s+WideMaxx(?:\s*\(\d+\))?$/i.test(text)) replacement = text.replace(/^1\/6/i, '1/10');
      if (!replacement || replacement === text) return;
      var leaf = Array.prototype.find.call(node.childNodes || [], function (child) { return child && child.nodeType === 3 && /1\/6/i.test(child.nodeValue || ''); });
      if (leaf) leaf.nodeValue = leaf.nodeValue.replace(/1\/6/i, '1/10');
      else node.textContent = replacement;
      node.setAttribute('data-integy-v495-scale-normalized', 'true');
    });
  }

  function shortenFilterButtons(scope) {
    if (!compactPhone()) return;
    all('[data-productgrid-trigger-filters] .utils-filter-text, .utils-filter-button .utils-filter-text', scope || document).forEach(function (label) {
      if (!label.getAttribute('data-integy-v473-original')) label.setAttribute('data-integy-v473-original', cleanText(label.textContent));
      if (cleanText(label.textContent) !== 'Filters') label.textContent = 'Filters';
    });
  }


  function normalizeMobileOverview(scope) {
    if (!broadMobile() || !document.body.classList.contains('template-product')) return;
    var descriptions = all('.product-block--description .product-description[data-product-description], .product-description[data-product-description]', scope || document);
    descriptions.forEach(function (description) {
      if (description.getAttribute('data-integy-v477-overview-ready') === 'true') return;
      description.setAttribute('data-integy-v477-overview-ready', 'true');
      var plain = cleanText(description.textContent);
      if (plain.length < 520) return;
      description.classList.add('integy-v477-overview-collapsible');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'integy-v477-overview-toggle';
      button.textContent = 'Read full overview';
      button.setAttribute('aria-expanded', 'false');
      description.insertAdjacentElement('afterend', button);
      button.addEventListener('click', function () {
        var expanded = description.classList.toggle('integy-v477-overview-expanded');
        button.textContent = expanded ? 'Show less' : 'Read full overview';
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  function normalizeCartPayments(scope) {
    if (!compactPhone() || !document.body.classList.contains('template-cart')) return;
    all('.additional-checkout-buttons', scope || document).forEach(function (box) {
      box.classList.add('integy-v464-checkout-buttons');
      box.style.removeProperty('height');
      box.style.removeProperty('min-height');
      all('[data-shopify-buttoncontainer],.shopify-cleanslate,ul,li,div,iframe', box).forEach(function (node) {
        if (node.tagName === 'IFRAME') {
          node.style.setProperty('max-height', '52px', 'important');
          node.style.setProperty('min-height', '44px', 'important');
          node.style.setProperty('height', '52px', 'important');
        } else {
          ['height','min-height','max-height'].forEach(function (name) { node.style.removeProperty(name); });
        }
      });
      all('div,li', box).forEach(function (node) {
        if (!node.children.length && !cleanText(node.textContent)) node.classList.add('integy-v464-empty-payment-node');
      });
    });
  }

  function mobileMaintenance(scope) {
    shortenFilterButtons(scope || document);
    normalizeMobileOverview(scope || document);
    normalizeCartPayments(scope || document);
    if (compactPhone()) {
      var logo = query('.site-header-logo .site-logo-image,.site-logo img');
      if (logo) logo.setAttribute('data-integy-v464-mobile-logo', 'true');
    }
  }

  function activeDrawerVisible() {
    return all('[data-productgrid-sidebar],.productgrid--sidebar,.mobile-facets,.integy-filter-drawer').some(function (element) {
      if (!element) return false;
      var style = getComputedStyle(element);
      var rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 160 && rect.height > 120;
    });
  }

  function interactionHygiene(scope) {
    all('[data-productgrid-trigger-filters],.utils-filter-button', scope || document).forEach(function (button) {
      button.setAttribute('aria-haspopup','dialog');
    });
    all('[data-mobile-search-button],.site-header-mobile-search-button', scope || document).forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label','Search');
      button.setAttribute('aria-haspopup','dialog');
    });
    all('[data-integy-v449-stock-status]', scope || document).forEach(function (status) {
      status.setAttribute('role','status');
      status.setAttribute('aria-live','polite');
      status.setAttribute('aria-atomic','true');
    });
    if (!activeDrawerVisible() && !root.classList.contains('integy-v466-filter-open')) {
      root.classList.remove('integy-v436-filter-open','integy-v440-filter-open','integy-v444-filter-open');
      all('.integy-v436-filter-backdrop,.integy-v440-filter-backdrop,.integy-v444-filter-backdrop,.integy-v426-filter-backdrop').forEach(function (node) { node.remove(); });
      if (document.body) {
        document.body.classList.remove('integy-v444-filter-lock');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('touch-action');
      }
    }
  }

  function normalizeSearchPageShell(scope) {
    if (!document.body || !document.body.classList.contains('template-search')) return;
    var searchValue = '';
    try { searchValue = new URL(window.location.href).searchParams.get('q') || ''; } catch (error) {}
    var performed = String(searchValue).trim().length > 0;
    document.body.classList.toggle('integy-search-performed', performed);

    all('input[type="search"],input[name="q"]', scope || document).forEach(function (input) {
      var placeholder = input.getAttribute('placeholder');
      if (!placeholder || placeholder === 'search.form.placeholder') input.setAttribute('placeholder', 'What are you looking for?');
    });

    var blankOnly = [
      '.productgrid--sidebar',
      '[data-productgrid-trigger-filters]',
      '.productgrid--utils-container',
      '.productgrid--utils-sticky-intersection'
    ].join(',');
    all(blankOnly, document).forEach(function (node) {
      if (!performed) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
        node.setAttribute('data-integy-v520-blank-search-hidden', 'true');
      } else if (node.getAttribute('data-integy-v520-blank-search-hidden') === 'true') {
        node.hidden = false;
        node.removeAttribute('aria-hidden');
        node.removeAttribute('data-integy-v520-blank-search-hidden');
      }
    });
  }

  function polishScope(scope) {
    normalizeSearchPageShell(scope || document);
    cleanGenericFitment(scope || document);
    normalizeDynamicTypes(scope || document);
    normalizeLegacyVehicleScaleLabels(scope || document);
    sortFilterLists(scope || document);
    interactionHygiene(scope || document);
    mobileMaintenance(scope || document);
  }

  function normalizeFitText(text) {
    return String(text || '').replace(/^\s*Fits:\s*/i, '').replace(/\s+/g, ' ').trim();
  }

  function cleanGenericFitment(scope) {
    all('.integy-v426-card-fits', scope || document).forEach(function (node) {
      if (GENERIC_FITMENT.test(normalizeFitText(node.textContent))) node.remove();
    });
  }

  function relevantAddedNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('[data-product-item],.productgrid--item,[data-product-recommendations],[data-integy-v501-related-grid],[data-recently-viewed-container],.product-recently-viewed__content,.product-recently-viewed-card,.flickity-viewport,.flickity-slider,[data-integy-static-model-filter-list],[data-integy-v200-static-part-filter-list],ul.collection-filters__filter-list,.live-search,.additional-checkout-buttons')) return true;
    return !!query('[data-product-item],.productgrid--item,[data-product-recommendations],[data-integy-v501-related-grid],[data-recently-viewed-container],.product-recently-viewed__content,.product-recently-viewed-card,.flickity-viewport,.flickity-slider,[data-integy-static-model-filter-list],[data-integy-v200-static-part-filter-list],ul.collection-filters__filter-list,.live-search,.additional-checkout-buttons', node);
  }

  function schedulePolish(scope) {
    if (scope && scope.nodeType === 1) pendingScopes.push(scope);
    if (polishTimer) return;
    polishTimer = window.setTimeout(function () {
      polishTimer = 0;
      var scopes = pendingScopes.splice(0, pendingScopes.length);
      if (!scopes.length || scopes.length > 8) {
        polishScope(document);
      } else {
        var unique = [];
        scopes.forEach(function (candidate) {
          if (!candidate || !candidate.isConnected || unique.some(function (existing) { return existing === candidate || existing.contains(candidate); })) return;
          unique = unique.filter(function (existing) { return !candidate.contains(existing); });
          unique.push(candidate);
        });
        unique.forEach(function (candidate) { polishScope(candidate); });
        sortFilterLists(document);
      }
      if (activeSearch && root.classList.contains('integy-v446-search-open')) ensureQuickPanel(activeSearch);
    }, 60);
  }

  function startObservers() {
    polishScope(document);
    if (!window.MutationObserver || !document.body || commerceObserver) return;
    commerceObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (relevantAddedNode(node)) schedulePolish(node.nodeType === 1 ? node : record.target);
        });
      });
    });
    commerceObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click' , function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-mobile-search-button], .site-header-mobile-search-button') : null;
    if (button && compactCommerce()) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openSearch(button);
      return;
    }

    var cancel = event.target && event.target.closest ? event.target.closest('[data-live-search-takeover-cancel], .integy-v464-search-close') : null;
    if (cancel && root.classList.contains('integy-v446-search-open')) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      closeSearch();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (!compactCommerce() || root.classList.contains('integy-v446-search-open')) return;
    var legacySearch = event.target && event.target.closest ? event.target.closest('.site-header .live-search') : null;
    if (!legacySearch) return;
    var button = query('[data-mobile-search-button],.site-header-mobile-search-button');
    if (button) openSearch(button);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('integy-v446-search-open')) {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
      return;
    }
    if (event.key === 'Tab' && activeSearch && root.classList.contains('integy-v446-search-open')) {
      var focusable = all('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', activeSearch).filter(function (node) {
        return node.offsetParent !== null && !node.hidden;
      });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!root.classList.contains('integy-v446-search-open')) return;
    var form = event.target;
    if (form && form.matches && form.matches('form[action*="/search"], form[role="search"]')) {
      var input = query('input[type="search"][name="q"]', form);
      if (input && !String(input.value || '').trim()) {
        event.preventDefault();
        input.focus();
      }
    }
  }, true);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSearchVisualViewport, { passive: true });
    /* INTEGY V532: in landscape Safari can pan the visual viewport after the
       keyboard is already open without another resize. Keep the takeover aligned
       to that visible viewport. The module's singleton guard guarantees one
       listener, and the scheduler is a no-op unless the search takeover is open. */
    window.visualViewport.addEventListener('scroll', scheduleSearchVisualViewport, { passive: true });
  }
  document.addEventListener('focusin', function (event) {
    if (root.classList.contains('integy-v446-search-open') && event.target && event.target.matches && event.target.matches('input[type="search"],input[name="q"]')) scheduleSearchVisualViewport();
  }, true);
  document.addEventListener('input', function (event) {
    if (root.classList.contains('integy-v446-search-open') && event.target && event.target.matches && event.target.matches('input[type="search"],input[name="q"]')) scheduleSearchVisualViewport();
  }, true);

  window.addEventListener('pageshow', function () { classifyDeviceLayout(); root.classList.remove('integy-v462-header-hidden'); closeSearch({ skipFocus: true }); normalizeSearchPageShell(document); schedulePolish(document.body); requestCompactHeader(); });
  window.addEventListener('orientationchange', function () {
    scheduleDeviceLayout();
    root.classList.remove('integy-v462-header-hidden');
    closeSearch({ skipFocus: true });
    window.setTimeout(function () { closeSearch({ skipFocus: true }); scheduleDeviceLayout(); requestCompactHeader(); }, 120);
    window.setTimeout(function () { closeSearch({ skipFocus: true }); schedulePolish(document.body); requestCompactHeader(); }, 360);
  });
  window.addEventListener('resize', function () {
    scheduleDeviceLayout();
    if (root.classList.contains('integy-v446-search-open') && !compactCommerce()) closeSearch({ skipFocus: true });
    else if (root.classList.contains('integy-v446-search-open')) scheduleSearchVisualViewport();
    requestCompactHeader();
    schedulePolish(document.body);
  }, { passive: true });


  window.addEventListener('scroll', requestCompactHeader, { passive: true });
  window.addEventListener('focusin', function () { root.classList.remove('integy-v462-header-hidden'); requestCompactHeader(); });
  document.addEventListener('focusin', function () { root.classList.remove('integy-v462-header-hidden'); requestCompactHeader(); }, true);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-menu-toggle],.site-header-mobile-search-button,[data-productgrid-trigger-filters]')) {
      root.classList.remove('integy-v462-header-hidden');
      window.setTimeout(requestCompactHeader, 60);
      window.setTimeout(function () { normalizeLegacyVehicleScaleLabels(document); }, 80);
    }
  }, true);

  function init() {
    classifyDeviceLayout();
    all('[data-mobile-search-button],.site-header-mobile-search-button').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', 'integy-v520-mobile-search');
    });
    var search = query('[data-site-header-main] [data-integy-v426-search], [data-site-header-main] .live-search, .site-header [data-integy-v426-search], .site-header .live-search');
    if (search) {
      search.id = search.id || 'integy-v520-mobile-search';
      bindVisibleInput(query('input[type="search"][name="q"], input[type="search"]', search));
    }
    startObservers();
    requestCompactHeader();
  }

  window.IntegyV520CommerceOwner.open = window.IntegyV501CommerceOwner.open = window.IntegyV500CommerceOwner.open = window.IntegyV495CommerceOwner.open = openSearch;
  window.IntegyV520CommerceOwner.close = window.IntegyV501CommerceOwner.close = window.IntegyV500CommerceOwner.close = window.IntegyV495CommerceOwner.close = closeSearch;
  window.IntegyV520CommerceOwner.syncSearchVisualViewport = window.IntegyV501CommerceOwner.syncSearchVisualViewport = window.IntegyV500CommerceOwner.syncSearchVisualViewport = window.IntegyV495CommerceOwner.syncSearchVisualViewport = scheduleSearchVisualViewport;
  window.IntegyV495CommerceOwner.ensureQuickPanel = ensureQuickPanel;
  window.IntegyV520CommerceOwner.compactPhone = window.IntegyV495CommerceOwner.compactPhone = compactPhone;
  window.IntegyV520CommerceOwner.compactCommerce = compactCommerce;
  window.IntegyV495CommerceOwner.polishScope = polishScope;
  window.IntegyV495CommerceOwner.sortFilterLists = sortFilterLists;
  window.IntegyV495CommerceOwner.schedulePolish = schedulePolish;
  window.IntegyV495CommerceOwner.mobileMaintenance = mobileMaintenance;



  document.addEventListener('shopify:section:load', function (event) { schedulePolish(event.target || document.body); });
  document.addEventListener('integy:filter-rendered', function () { schedulePolish(document.body); });
  document.addEventListener('integy:v298:filters-ready', function () { schedulePolish(document.body); });
  document.addEventListener('integy:v295:filters-ready', function () { schedulePolish(document.body); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


;
